import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cp-fieldgetics-news',
  templateUrl: './fieldgetics-news.component.html',
  styleUrls: ['./fieldgetics-news.component.css']
})
export class FieldgeticsNewsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
